import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_EVENT_PAGE_NUMBER,
    CLEAR_EVENT_PAGE_NUMBER_ERROR,
    LOAD_EVENT_PAGE_NUMBER_REQUEST,
    LOAD_EVENT_PAGE_NUMBER_SUCCESS,
    LOAD_EVENT_PAGE_NUMBER_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_EVENT_PAGE_NUMBER,
    CLEAR_ERROR: CLEAR_EVENT_PAGE_NUMBER_ERROR,
    LOAD_REQUEST: LOAD_EVENT_PAGE_NUMBER_REQUEST,
    LOAD_SUCCESS: LOAD_EVENT_PAGE_NUMBER_SUCCESS,
    LOAD_FAILURE: LOAD_EVENT_PAGE_NUMBER_FAILURE
}